module.exports = __webpack_public_path__ + "static/media/Buvidal_Monthly_Product_Information.cea07f53.pdf";